export default __webpack_public_path__ + "img/bg-tab1and2_nav2-201cd555.png";